import { useState, useEffect } from 'react';
import { getIsDark, getThemeColors, subscribe } from './themeState';

// Hook that re-renders component when theme changes
export const useAppTheme = () => {
  const [isDark, setIsDark] = useState(getIsDark());

  useEffect(() => {
    const unsubscribe = subscribe((newIsDark) => {
      setIsDark(newIsDark);
    });
    return unsubscribe;
  }, []);

  return {
    isDark,
    colors: getThemeColors(),
  };
};
